export function toLocaleString(value, options) {
	let date;
	if (value instanceof Date) {
		date = value;
	} else {
		value = String(value) || '';
		date = new Date(value || Date.now());
	}

	//Refence: https://www.timeanddate.com/time/zone/usa
	//Reference: http://time-time.net/times/time-zones/usa-canada/current-eastern-time-est.php
	let abbr = 'GMT';
	if (options?.hour) {
		const timeString = date.toTimeString();
		abbr = timeString.match(/\([a-z ]+\)/i);

		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}
	}

	let result = date.toLocaleString(['en-US'], options);
	let dateTimeWithoutComma = result.replace(",", " ")

	if (abbr !== 'GMT') {
		dateTimeWithoutComma += ' ' + abbrZone(abbr);
	}

	return dateTimeWithoutComma;
}

export function abbrZone(abbr) {
	switch (abbr) {
		case 'PDT':
		case 'PST':
			return 'PT';
		case 'MST':
		case 'MDT':
			return 'MT';
		case 'CDT':
		case 'CST':
			return 'CT';
		case 'EDT':
		case 'EST':
			return 'ET';
		default:
			return abbr;
	}
}
